import { render, staticRenderFns } from "./ArrowsAltHIcon.vue?vue&type=template&id=38eaa0e0&"
import script from "./ArrowsAltHIcon.vue?vue&type=script&lang=js&"
export * from "./ArrowsAltHIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports